export interface PerformanceMetric {
    source: DataSource;
    method: string;
    path: string;
    payload?: unknown;
    params?: Record<string, unknown>;
    requestTime: number;
    requestSize?: number;
    responseSize?: number;
    statusCode?: number;
    isTimeout?: boolean;
    errorMessage?: string;
}

export enum DataSource {
    API = 'api',
    CDN = 'cdn',
    UNKNOWN = 'unknown',
}
